<template>
  <div class="p-4">
    <PrimeProgressBar
      mode="indeterminate"
      style="height: 6px"
    ></PrimeProgressBar>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
